<template>
  <header class="marketing-automation-detail-header">
    <div class="marketing-automation-detail-header-body">
      <h1 class="marketing-automation-detail-header-body-name">{{ automationName }}</h1>

      <header-saving :saving="needsSaving"
                     :saving-text="$t('message.automation.message.changesToBeSaved')" />
    </div>
  </header>
</template>

<script>
import HeaderSaving from "@/components/generic/header/saving/HeaderSaving";
import EventBus from "@packages/event-bus";

export default {
  components: {
    HeaderSaving,
  },

  props: {},

  computed: {
    needsSaving() {
      return this.$store.state.marketing.automation.edit.needsSaving;
    },
  },

  mounted() {
    EventBus.$on("SET_AUTOMATION_DETAIL_NAME", this.setAutomationName);
  },

  beforeDestroy() {
    EventBus.$off("SET_AUTOMATION_DETAIL_NAME", this.setAutomationName);
  },

  data() {
    return {
      automationName: undefined,
    };
  },

  methods: {
    setAutomationName(name) {
      this.automationName = name;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@variables";

.marketing-automation-detail-header {
  display: flex;
  align-items: flex-end;
  border-bottom: 1px solid rgba($grey-4, 0.27);
  padding-left: 50px;

  .marketing-automation-detail-header-body {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex: 1;

    .marketing-automation-detail-header-body-name {
      color: #707070;
      font-size: 28px;
    }
  }
}
</style>
